import HistoryBackArrow from './HistoryBackArrow';

export default HistoryBackArrow;
